// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/Logo_exp.png";
import { MailIcon, PhoneIcon } from "./Icons";
import { socialLinks } from "../socialLinks";

const LINK_COLUMNS = [
  {
    title: "Loans",
    links: [
      { to: "/services/mortgages", label: "Mortgages" },
      { to: "/services/first-home-buyers", label: "First Home Buyers" },
      { to: "/services/investment-property", label: "Investment Property" },
      { to: "/services/refinancing", label: "Refinancing" },
      { to: "/services/construction-loans", label: "Construction Loans" },
      { to: "/services/commercial-property", label: "Commercial Property" },
    ],
  },
  {
    title: "Protection & Insurance",
    links: [
      { to: "/services/life-insurance", label: "Life Insurance" },
      { to: "/services/income-protection", label: "Income Protection" },
      { to: "/services/health-trauma", label: "Health & Trauma" },
      { to: "/services/mortgage-protection", label: "Mortgage Protection" },
    ],
  },
  {
    title: "Business",
    links: [
      { to: "/services/business-loans", label: "Business Loans" },
      { to: "/services/business-finance", label: "Business Finance" },
      { to: "/services/equipment-finance", label: "Equipment Finance" },
      { to: "/calculator", label: "Loan Calculator" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About Us" },
      { to: "/about/team", label: "Our Team" },
      { to: "/about/careers", label: "Careers" },
      { to: "/contact", label: "Contact" },
    ],
  },
];

const PinIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 21s-7-6.1-7-11.5a7 7 0 0 1 14 0C19 14.9 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand / contact */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Expert Finance home">
              <img src={logo} alt="Expert Finance" />
            </Link>
            <p className="footer-about">
              Independent mortgage, insurance and business finance advisers,
              working with first home buyers, investors and business owners.
            </p>

            <div className="footer-social">
              {socialLinks.map(({ label, icon, href }) => (
                <a
                  key={label}
                  className="footer-social-link"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  /* No visible text here, so the link needs its own label */
                  aria-label={`Expert Finance on ${label}`}
                >
                  <img src={icon} alt="" />
                </a>
              ))}
            </div>
          </div>

          {LINK_COLUMNS.map((column) => (
            <nav
              key={column.title}
              className="footer-col"
              aria-label={column.title}
            >
              <h4 className="footer-heading">{column.title}</h4>
              <ul className="footer-list">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        {/* Contact details get their own row so the brand column stays the
            same height as the link columns beside it */}
        <ul className="footer-contact-row">
          <li>
            <span className="footer-contact-icon">
              <PinIcon />
            </span>
            <span>
              <span className="footer-contact-label">Visit</span>
              <address>
                Suite E3, 123 Ormiston Road, Flat Bush, Auckland 2019
              </address>
            </span>
          </li>
          <li>
            <span className="footer-contact-icon">
              <PhoneIcon size={18} />
            </span>
            <span>
              <span className="footer-contact-label">Call</span>
              <a href="tel:+6492176765">09-2176765</a>
            </span>
          </li>
          <li>
            <span className="footer-contact-icon">
              <MailIcon size={18} />
            </span>
            <span>
              <span className="footer-contact-label">Email</span>
              <a href="mailto:info@expertfinance.co.nz">info@expertfinance.co.nz</a>
            </span>
          </li>
        </ul>

        {/* Bottom strip */}
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Expert Finance Ltd. All rights
            reserved. Service area: New Zealand wide.
          </p>
          <ul className="footer-legal">
            <li>
              <Link to="/about/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/about/disclosure">Disclosure</Link>
            </li>
            <li>FSP1003967</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
